import {put, takeEvery, takeLatest} from "redux-saga/effects";
import {Order} from "../../../Models/Order";
import {fillItems, loadOrRequest} from "../../utils";
import {
    orderActiveError,
    orderActiveSuccess,
    orderCreateError,
    orderCreateSuccess,
    orderLoadError,
    orderLoadSuccess,
    ordersGetError,
    ordersGetSuccess,
    orderUpdateError,
    orderUpdateSuccess,
} from "./actions";
import * as TYPES from "./types";

export default function* ordersSagas() {
    yield takeEvery(TYPES.ORDERS_GET_REQUEST, ordersGetRequest);
    yield takeEvery(TYPES.ORDER_LOAD_REQUEST, orderLoadRequest);
    yield takeEvery(TYPES.ORDER_CREATE_REQUEST, orderCreateRequest);
    yield takeEvery(TYPES.ORDER_UPDATE_REQUEST, orderUpdateRequest);

    yield takeLatest(TYPES.ACTIVE_REQUEST, orderActiveRequest);
}

function* ordersGetRequest(action) {
    try {
        const response = yield Order.index({
            ...action.payload,
        });

        yield put(
            ordersGetSuccess({
                ...fillItems(response, Order),
                _params: action.payload,
            })
        );
    } catch (error) {
        yield put(ordersGetError(error));
    }
}

function* orderLoadRequest(action) {
    try {
        const response = yield Order.find(action.payload);

        yield put(
            orderLoadSuccess({
                ...response,
                _params: action.payload,
            })
        );
    } catch (error) {
        yield put(orderLoadError(error));
    }
}

function* orderCreateRequest(action) {
    try {
        const response = yield Order.create(action.payload);

        yield put(
            orderCreateSuccess({
                ...response,
                _params: action.payload,
            })
        );
    } catch (error) {
        yield put(orderCreateError(error));
    }
}

function* orderUpdateRequest(action) {
    try {
        const response = yield Order.update(action.payload.id, action.payload);

        yield put(
            orderUpdateSuccess({
                ...response,
                _params: action.payload,
            })
        );
    } catch (error) {
        yield put(orderUpdateError(error));
    }
}

function* orderActiveRequest({payload}) {
    try {
        const response = yield loadOrRequest("Orders", payload.id, (id) => Order.find(id, payload));
        yield put(orderActiveSuccess(response));
    } catch (err) {
        const {response} = err;
        console.error(err);

        yield put(orderActiveError(response));
    }
}
